import React from 'react'
import divi from '../assets/divi.svg' 

export const Intro = () => {
  return (
    <> 
<div className='flex justify-between '>

<div className=' '>   
   <div className='     dots-main hidden md:block '>
         <div className='flex my-2 '>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex my-3 ml-10 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-1 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>
           <div className='flex my-6 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-2 ml-11'>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>
         
         </div>
         </div>


    <div className=' mr-16 '>
   <div className='   dots-main hidden md:block lg:block'>
         <div className='flex my-2 '>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex my-3 ml-10 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-1 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>
           <div className='flex my-6 '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           </div>
           <div className='flex my-2 ml-11'>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-5'></span>
           <span className='bg-[#f1f5f8] h-7 w-6 rounded-full mx-2'></span>
           </div>
           <div className='flex '>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-1'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-6'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           <span className='bg-[#f1f5f8] h-7 w-6   rounded-full mx-3'></span>
           </div>

           </div> 
         </div>


         </div>
    
     

        <div className=' md:-mt-[18%] md:w-[80%]  mx-auto px-4 my-7'>
            <div>
            <center>
            <h1 className='text-center   font-Outfit text-[#272C34] text-[24px] font-semibold '>Introduction</h1>
            <img src={divi} alt='divider' className='-mt-9' />
            </center>
            <p className='intro-main text-center text-[#272C34] text-[12px]   px-3'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam cursus,
            sapien vitae interdum congue, orci tellus condimentum enim, eu venenatis
             diam ante nec lorem. Nullam ex nisl, tincidunt quis condimentum quis, tincidunt
             eu nisl. Pellentesque nisi lectus, imperdiet id aliquam sit amet, malesuada non 
             libero. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse vehicula 
             massa eget posuere mollis. Suspendisse bibendum pulvinar fringilla. Nullam sagittis
              scelerisque purus, aliquam suscipit justo ultrices id. Donec tristique tempor turpis
              , ac volutpat tortor pulvinar a. Ut auctor magna neque, ultricies tincidunt libero
               commodo eu. Ut elit purus, luctus vel eleifend vitae, iaculis at augue. Aenean id tellus
                nec velit bibendum pulvinar. Praesent viverra iaculis ex sed efficitur. Lorem ipsum dolor
                 sit amet, consectetur adipiscing elit. Nunc sodales sed enim ac aliquet.</p>
                 
                  
            </div>
            </div>


 
           {/* <a href='#movetotop' > <button  className='bg-gray-800 h-12 w-12'  id="myBtn" title="Go to top">Top</button> </a> */}

 
            </>

  )
}
